import { render } from "./copy-button.vue?vue&type=template&id=8a05da8c"
import script from "./copy-button.vue?vue&type=script&lang=js"
export * from "./copy-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__